import { render, staticRenderFns } from "./Bubbles.vue?vue&type=template&id=1f867db4&scoped=true&"
import script from "./Bubbles.vue?vue&type=script&lang=js&"
export * from "./Bubbles.vue?vue&type=script&lang=js&"
import style0 from "./Bubbles.vue?vue&type=style&index=0&id=1f867db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f867db4",
  null
  
)

export default component.exports